module.exports = __webpack_public_path__ + "img/beer_id-56.464bf0ea.png";